import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { cloneObj } from "../../util/varibles/global";
import { IOperation2, TOperation2 } from "../../util/varibles/interface";
import { initialState, IVesselOfUser } from './constants';

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        getUserRequest: (state, action: PayloadAction<{ action: any } | undefined>) => {
        },
        getUserSuccess: (state, action) => {
            state.user = action.payload;
        },
        loginRequest: (state, action) => {
        },
        logout: (state) => {
        },
        deleteOpOfVessel: (state, action) => {
        },
        getDomainsRequest: () => {
        },
        getDomainsSuccess: (state, action) => {
            state.domains = action.payload;
        },
        updateUserSetting: (state, action) => {
            const [setting, args] = action.payload;
            const { default_vessel } = args || {};
            const { user } = state;
            state.loadingSetting = true;
            state.user = {
                ...user,
                setting: { ...user.setting, ...setting },
                default_vessel: default_vessel || state.user?.default_vessel || ''
            };
        },
        updateLoadingUserSetting: (state) => {
            state.loadingSetting = false;
        },
        addDomain: (state, action) => {
            const { domain } = action.payload;
            const { domains } = state;
            state.domains = [...domains, domain];
        },
        updateLoadingUser: (state, action: PayloadAction<boolean>) => {
            state.loadingUser = action.payload
        },
        updateAccount: (state, action) => {
            const { user } = state;
            state.user = { ...user, ...action.payload.user };
        },
        getOpsOfVessel: () => {
        },
        getOpsOfVesselRequest: (state) => {
            state.loadingDashboard = true
        },
        getOpsOfVesselSuccess: (state, action) => {
            const vessels = action.payload;
            state.loadingDashboard = false;
            state.vessels = vessels.map((item: any) => {
                const { operations, vessel_id, vessel_type, ...args } = item;
                return {
                    ...item,
                    id: vessel_id,
                    type: vessel_type,
                    operations: operations.map((sub: any) => ({
                        ...sub,
                        vessel: { ...args, id: vessel_id, type: vessel_type }
                    }))
                }
            })
        },
        getOpsOfVesselFailure: (state) => {
            state.loadingDashboard = false
        },
        updateOpOfVessel: (state, action: PayloadAction<IOperation2>) => {
            const data = action.payload;
            const { id, vessel_id } = data.operation;
            const { vessels } = state;
            state.vessels = vessels.map(item => {
                if (item.vessel_id === vessel_id) {
                    const { operations } = item;
                    return {
                        ...item,
                        operations: operations.map(sub => sub.operation.id === id ? data : sub)
                    }
                }
                return item;
            })
        },
        updateOpsOfVessel: (state, action) => {
            const operations = action.payload;
            const { vessels } = state;

            state.vessels = operations.reduce((rs: IVesselOfUser[], item: IOperation2) => {
                const { id, vessel_id } = item.operation;
                const indexVessel = rs.findIndex(vessel => vessel.vessel_id === vessel_id);
                if (indexVessel !== -1) {
                    const { operations, ...vessel } = rs[indexVessel];
                    if (operations.length === 0) {
                        rs[indexVessel].operations = [{ ...item, vessel }]
                    } else {
                        const indexOperation = operations.findIndex(op => op.operation.id === id);
                        if (indexOperation !== -1) {
                            const data = rs[indexVessel].operations[indexOperation];
                            rs[indexVessel].operations[indexOperation] = {
                                ...data,
                                ...item,
                                operation: { ...data.operation, ...item.operation } as TOperation2
                            }
                        }
                    }
                }
                return rs;
            }, cloneObj(vessels))
        },
        updateLoadingVesselSide: (state, action) => {
            state.loadingDashboard = action.payload
        },
        updateTenant: (state, action) => {
            const data = action.payload;
            const { user } = state;
            state.user = { ...user, tenant: { ...user.tenant || {}, ...data } }
        },
        isDashboardEnabled: (state, action: PayloadAction<boolean>) => {
            state.isDashboardEnabled = action.payload
        },
        updateWeather: (state, action: PayloadAction<{ vesselId: string, value: any }>) => {
            const { vesselId, value } = action.payload;
            state.weather = {
                ...state.weather || {},
                [vesselId]: value
            }
        }
    },
})

export const loginActions = loginSlice.actions;
export const { updateUserSetting } = loginActions;

const loginReducer = loginSlice.reducer;

export default loginReducer
